import React from "react";
import { StoreTeam } from "@coworker/types/lib/storeteam";
import { SwitcherSheet } from "./SwitcherSheet";
import { StoreEnvironmentSelector } from "./StoreEnvironmentSelector";
import { useTranslation } from "@coworker/locales";

interface SwitchTeamSheetProps {
  teams: StoreTeam[] | undefined;
  selectedTeam: StoreTeam | undefined;
  setSelectedTeam: React.Dispatch<React.SetStateAction<StoreTeam | undefined>>;
  setIsTeamsDisabled: React.Dispatch<React.SetStateAction<boolean>>;
  loading: boolean;
  isTeamsDisabled: boolean;
}

export const SwitchTeamSheet = (props: SwitchTeamSheetProps) => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = React.useState(false);
  return (
    <>
      <StoreEnvironmentSelector
        id="team"
        value={
          !props.isTeamsDisabled
            ? props.selectedTeam?.name!!
            : t("chooseAnOptionString")
        }
        disabled={props.isTeamsDisabled}
        label="teamString"
        validationMsg="pleaseSelectATeamString"
        selectedItem={props.selectedTeam}
        loading={props.loading}
        onClick={() => {
          setIsOpen(true);
        }}
      />
      <SwitcherSheet
        titleKey="teamString"
        placeholderKey="searchTeamString"
        items={props.teams ?? []}
        selectedItem={props.selectedTeam}
        getItemLabel={(team) => team?.name ?? ""}
        getItemKey={(team) => team?.id ?? ""}
        onSelect={props.setSelectedTeam}
        isDisabled={(teams) => props.setIsTeamsDisabled(teams.length === 0)}
        loading={props.loading}
        isOpen={isOpen}
        setIsOpen={setIsOpen}
      />
    </>
  );
};
